"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPageTitle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PageContent = require("../PageContent/PageContent");
var StyledPageTitle = /*#__PURE__*/(0, _styledComponents.default)(_PageContent.PageContent).withConfig({
  displayName: "StyledPageTitle",
  componentId: "c11n-8-107-0__sc-14zluhz-0"
})([""]);
exports.StyledPageTitle = StyledPageTitle;